export default "__VITE_ASSET__8e43919d__"